"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllSyncActionSignerResponse = exports.QueryAllSyncActionSignerRequest = exports.QueryGetSyncActionSignerResponse = exports.QueryGetSyncActionSignerRequest = exports.QueryAllActionSignerConfigResponse = exports.QueryAllActionSignerConfigRequest = exports.QueryGetActionSignerConfigResponse = exports.QueryGetActionSignerConfigRequest = exports.QueryGetBindedSignerResponse = exports.QueryGetBindedSignerRequest = exports.QueryAllActionSignerResponse = exports.QueryAllActionSignerRequest = exports.QueryGetActionSignerResponse = exports.QueryGetActionSignerRequest = exports.QueryGetOracleConfigResponse = exports.QueryGetOracleConfigRequest = exports.QueryAllCollectionOwnerRequestResponse = exports.QueryAllCollectionOwnerRequestRequest = exports.QueryGetCollectionOwnerRequestResponse = exports.QueryGetCollectionOwnerRequestRequest = exports.QueryAllActionRequestResponseV063 = exports.QueryAllActionRequestResponse = exports.QueryAllActionRequestRequest = exports.QueryGetActionRequestResponseV063 = exports.QueryGetActionRequestResponse = exports.QueryGetActionRequestRequest = exports.QueryAllMintRequestResponse = exports.QueryAllMintRequestRequest = exports.QueryGetMintRequestResponse = exports.QueryGetMintRequestRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = require("protobufjs/minimal");
const params_1 = require("../nftoracle/params");
const mint_request_1 = require("../nftoracle/mint_request");
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const action_request_1 = require("../nftoracle/action_request");
const collection_owner_request_1 = require("../nftoracle/collection_owner_request");
const oracle_config_1 = require("../nftoracle/oracle_config");
const action_signer_1 = require("../nftoracle/action_signer");
const binded_signer_1 = require("../nftoracle/binded_signer");
const action_signer_config_1 = require("../nftoracle/action_signer_config");
const sync_action_signer_1 = require("../nftoracle/sync_action_signer");
exports.protobufPackage = "thesixnetwork.sixnft.nftoracle";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryGetMintRequestRequest = { id: 0 };
exports.QueryGetMintRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMintRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMintRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMintRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseQueryGetMintRequestResponse = {};
exports.QueryGetMintRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.MintRequest !== undefined) {
            mint_request_1.MintRequest.encode(message.MintRequest, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMintRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.MintRequest = mint_request_1.MintRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMintRequestResponse);
        if (object.MintRequest !== undefined && object.MintRequest !== null) {
            message.MintRequest = mint_request_1.MintRequest.fromJSON(object.MintRequest);
        }
        else {
            message.MintRequest = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.MintRequest !== undefined &&
            (obj.MintRequest = message.MintRequest
                ? mint_request_1.MintRequest.toJSON(message.MintRequest)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMintRequestResponse);
        if (object.MintRequest !== undefined && object.MintRequest !== null) {
            message.MintRequest = mint_request_1.MintRequest.fromPartial(object.MintRequest);
        }
        else {
            message.MintRequest = undefined;
        }
        return message;
    },
};
const baseQueryAllMintRequestRequest = {};
exports.QueryAllMintRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMintRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMintRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMintRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllMintRequestResponse = {};
exports.QueryAllMintRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.MintRequest) {
            mint_request_1.MintRequest.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMintRequestResponse);
        message.MintRequest = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.MintRequest.push(mint_request_1.MintRequest.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMintRequestResponse);
        message.MintRequest = [];
        if (object.MintRequest !== undefined && object.MintRequest !== null) {
            for (const e of object.MintRequest) {
                message.MintRequest.push(mint_request_1.MintRequest.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.MintRequest) {
            obj.MintRequest = message.MintRequest.map((e) => e ? mint_request_1.MintRequest.toJSON(e) : undefined);
        }
        else {
            obj.MintRequest = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMintRequestResponse);
        message.MintRequest = [];
        if (object.MintRequest !== undefined && object.MintRequest !== null) {
            for (const e of object.MintRequest) {
                message.MintRequest.push(mint_request_1.MintRequest.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetActionRequestRequest = { id: 0 };
exports.QueryGetActionRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseQueryGetActionRequestResponse = {};
exports.QueryGetActionRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ActionOracleRequest !== undefined) {
            action_request_1.ActionOracleRequest.encode(message.ActionOracleRequest, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ActionOracleRequest = action_request_1.ActionOracleRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionRequestResponse);
        if (object.ActionOracleRequest !== undefined &&
            object.ActionOracleRequest !== null) {
            message.ActionOracleRequest = action_request_1.ActionOracleRequest.fromJSON(object.ActionOracleRequest);
        }
        else {
            message.ActionOracleRequest = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ActionOracleRequest !== undefined &&
            (obj.ActionOracleRequest = message.ActionOracleRequest
                ? action_request_1.ActionOracleRequest.toJSON(message.ActionOracleRequest)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionRequestResponse);
        if (object.ActionOracleRequest !== undefined &&
            object.ActionOracleRequest !== null) {
            message.ActionOracleRequest = action_request_1.ActionOracleRequest.fromPartial(object.ActionOracleRequest);
        }
        else {
            message.ActionOracleRequest = undefined;
        }
        return message;
    },
};
const baseQueryGetActionRequestResponseV063 = {};
exports.QueryGetActionRequestResponseV063 = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ActionRequestV063 !== undefined) {
            action_request_1.ActionRequestV063.encode(message.ActionRequestV063, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionRequestResponseV063);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ActionRequestV063 = action_request_1.ActionRequestV063.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionRequestResponseV063);
        if (object.ActionRequestV063 !== undefined &&
            object.ActionRequestV063 !== null) {
            message.ActionRequestV063 = action_request_1.ActionRequestV063.fromJSON(object.ActionRequestV063);
        }
        else {
            message.ActionRequestV063 = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ActionRequestV063 !== undefined &&
            (obj.ActionRequestV063 = message.ActionRequestV063
                ? action_request_1.ActionRequestV063.toJSON(message.ActionRequestV063)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionRequestResponseV063);
        if (object.ActionRequestV063 !== undefined &&
            object.ActionRequestV063 !== null) {
            message.ActionRequestV063 = action_request_1.ActionRequestV063.fromPartial(object.ActionRequestV063);
        }
        else {
            message.ActionRequestV063 = undefined;
        }
        return message;
    },
};
const baseQueryAllActionRequestRequest = {};
exports.QueryAllActionRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllActionRequestResponse = {};
exports.QueryAllActionRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.ActionOracleRequest) {
            action_request_1.ActionOracleRequest.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionRequestResponse);
        message.ActionOracleRequest = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ActionOracleRequest.push(action_request_1.ActionOracleRequest.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionRequestResponse);
        message.ActionOracleRequest = [];
        if (object.ActionOracleRequest !== undefined &&
            object.ActionOracleRequest !== null) {
            for (const e of object.ActionOracleRequest) {
                message.ActionOracleRequest.push(action_request_1.ActionOracleRequest.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ActionOracleRequest) {
            obj.ActionOracleRequest = message.ActionOracleRequest.map((e) => e ? action_request_1.ActionOracleRequest.toJSON(e) : undefined);
        }
        else {
            obj.ActionOracleRequest = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionRequestResponse);
        message.ActionOracleRequest = [];
        if (object.ActionOracleRequest !== undefined &&
            object.ActionOracleRequest !== null) {
            for (const e of object.ActionOracleRequest) {
                message.ActionOracleRequest.push(action_request_1.ActionOracleRequest.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllActionRequestResponseV063 = {};
exports.QueryAllActionRequestResponseV063 = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.ActionRequestV063) {
            action_request_1.ActionRequestV063.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionRequestResponseV063);
        message.ActionRequestV063 = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ActionRequestV063.push(action_request_1.ActionRequestV063.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionRequestResponseV063);
        message.ActionRequestV063 = [];
        if (object.ActionRequestV063 !== undefined &&
            object.ActionRequestV063 !== null) {
            for (const e of object.ActionRequestV063) {
                message.ActionRequestV063.push(action_request_1.ActionRequestV063.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.ActionRequestV063) {
            obj.ActionRequestV063 = message.ActionRequestV063.map((e) => e ? action_request_1.ActionRequestV063.toJSON(e) : undefined);
        }
        else {
            obj.ActionRequestV063 = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionRequestResponseV063);
        message.ActionRequestV063 = [];
        if (object.ActionRequestV063 !== undefined &&
            object.ActionRequestV063 !== null) {
            for (const e of object.ActionRequestV063) {
                message.ActionRequestV063.push(action_request_1.ActionRequestV063.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetCollectionOwnerRequestRequest = { id: 0 };
exports.QueryGetCollectionOwnerRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseQueryGetCollectionOwnerRequestResponse = {};
exports.QueryGetCollectionOwnerRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.CollectionOwnerRequest !== undefined) {
            collection_owner_request_1.CollectionOwnerRequest.encode(message.CollectionOwnerRequest, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.CollectionOwnerRequest = collection_owner_request_1.CollectionOwnerRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestResponse);
        if (object.CollectionOwnerRequest !== undefined &&
            object.CollectionOwnerRequest !== null) {
            message.CollectionOwnerRequest = collection_owner_request_1.CollectionOwnerRequest.fromJSON(object.CollectionOwnerRequest);
        }
        else {
            message.CollectionOwnerRequest = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.CollectionOwnerRequest !== undefined &&
            (obj.CollectionOwnerRequest = message.CollectionOwnerRequest
                ? collection_owner_request_1.CollectionOwnerRequest.toJSON(message.CollectionOwnerRequest)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetCollectionOwnerRequestResponse);
        if (object.CollectionOwnerRequest !== undefined &&
            object.CollectionOwnerRequest !== null) {
            message.CollectionOwnerRequest = collection_owner_request_1.CollectionOwnerRequest.fromPartial(object.CollectionOwnerRequest);
        }
        else {
            message.CollectionOwnerRequest = undefined;
        }
        return message;
    },
};
const baseQueryAllCollectionOwnerRequestRequest = {};
exports.QueryAllCollectionOwnerRequestRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllCollectionOwnerRequestResponse = {};
exports.QueryAllCollectionOwnerRequestResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.CollectionOwnerRequest) {
            collection_owner_request_1.CollectionOwnerRequest.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestResponse);
        message.CollectionOwnerRequest = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.CollectionOwnerRequest.push(collection_owner_request_1.CollectionOwnerRequest.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestResponse);
        message.CollectionOwnerRequest = [];
        if (object.CollectionOwnerRequest !== undefined &&
            object.CollectionOwnerRequest !== null) {
            for (const e of object.CollectionOwnerRequest) {
                message.CollectionOwnerRequest.push(collection_owner_request_1.CollectionOwnerRequest.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.CollectionOwnerRequest) {
            obj.CollectionOwnerRequest = message.CollectionOwnerRequest.map((e) => e ? collection_owner_request_1.CollectionOwnerRequest.toJSON(e) : undefined);
        }
        else {
            obj.CollectionOwnerRequest = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllCollectionOwnerRequestResponse);
        message.CollectionOwnerRequest = [];
        if (object.CollectionOwnerRequest !== undefined &&
            object.CollectionOwnerRequest !== null) {
            for (const e of object.CollectionOwnerRequest) {
                message.CollectionOwnerRequest.push(collection_owner_request_1.CollectionOwnerRequest.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetOracleConfigRequest = {};
exports.QueryGetOracleConfigRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOracleConfigRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryGetOracleConfigRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryGetOracleConfigRequest);
        return message;
    },
};
const baseQueryGetOracleConfigResponse = {};
exports.QueryGetOracleConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.OracleConfig !== undefined) {
            oracle_config_1.OracleConfig.encode(message.OracleConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOracleConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.OracleConfig = oracle_config_1.OracleConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetOracleConfigResponse);
        if (object.OracleConfig !== undefined && object.OracleConfig !== null) {
            message.OracleConfig = oracle_config_1.OracleConfig.fromJSON(object.OracleConfig);
        }
        else {
            message.OracleConfig = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.OracleConfig !== undefined &&
            (obj.OracleConfig = message.OracleConfig
                ? oracle_config_1.OracleConfig.toJSON(message.OracleConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetOracleConfigResponse);
        if (object.OracleConfig !== undefined && object.OracleConfig !== null) {
            message.OracleConfig = oracle_config_1.OracleConfig.fromPartial(object.OracleConfig);
        }
        else {
            message.OracleConfig = undefined;
        }
        return message;
    },
};
const baseQueryGetActionSignerRequest = {
    actorAddress: "",
    ownerAddress: "",
};
exports.QueryGetActionSignerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actorAddress !== "") {
            writer.uint32(10).string(message.actorAddress);
        }
        if (message.ownerAddress !== "") {
            writer.uint32(18).string(message.ownerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionSignerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actorAddress = reader.string();
                    break;
                case 2:
                    message.ownerAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionSignerRequest);
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = String(object.actorAddress);
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actorAddress !== undefined &&
            (obj.actorAddress = message.actorAddress);
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionSignerRequest);
        if (object.actorAddress !== undefined && object.actorAddress !== null) {
            message.actorAddress = object.actorAddress;
        }
        else {
            message.actorAddress = "";
        }
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
};
const baseQueryGetActionSignerResponse = {};
exports.QueryGetActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actionSigner !== undefined) {
            action_signer_1.ActionSigner.encode(message.actionSigner, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionSigner = action_signer_1.ActionSigner.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionSignerResponse);
        if (object.actionSigner !== undefined && object.actionSigner !== null) {
            message.actionSigner = action_signer_1.ActionSigner.fromJSON(object.actionSigner);
        }
        else {
            message.actionSigner = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actionSigner !== undefined &&
            (obj.actionSigner = message.actionSigner
                ? action_signer_1.ActionSigner.toJSON(message.actionSigner)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionSignerResponse);
        if (object.actionSigner !== undefined && object.actionSigner !== null) {
            message.actionSigner = action_signer_1.ActionSigner.fromPartial(object.actionSigner);
        }
        else {
            message.actionSigner = undefined;
        }
        return message;
    },
};
const baseQueryAllActionSignerRequest = {};
exports.QueryAllActionSignerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionSignerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionSignerRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionSignerRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllActionSignerResponse = {};
exports.QueryAllActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.actionSigner) {
            action_signer_1.ActionSigner.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionSignerResponse);
        message.actionSigner = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionSigner.push(action_signer_1.ActionSigner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionSignerResponse);
        message.actionSigner = [];
        if (object.actionSigner !== undefined && object.actionSigner !== null) {
            for (const e of object.actionSigner) {
                message.actionSigner.push(action_signer_1.ActionSigner.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.actionSigner) {
            obj.actionSigner = message.actionSigner.map((e) => e ? action_signer_1.ActionSigner.toJSON(e) : undefined);
        }
        else {
            obj.actionSigner = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionSignerResponse);
        message.actionSigner = [];
        if (object.actionSigner !== undefined && object.actionSigner !== null) {
            for (const e of object.actionSigner) {
                message.actionSigner.push(action_signer_1.ActionSigner.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetBindedSignerRequest = { ownerAddress: "" };
exports.QueryGetBindedSignerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.ownerAddress !== "") {
            writer.uint32(10).string(message.ownerAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBindedSignerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ownerAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetBindedSignerRequest);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = String(object.ownerAddress);
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.ownerAddress !== undefined &&
            (obj.ownerAddress = message.ownerAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetBindedSignerRequest);
        if (object.ownerAddress !== undefined && object.ownerAddress !== null) {
            message.ownerAddress = object.ownerAddress;
        }
        else {
            message.ownerAddress = "";
        }
        return message;
    },
};
const baseQueryGetBindedSignerResponse = {};
exports.QueryGetBindedSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.bindedSigner !== undefined) {
            binded_signer_1.BindedSigner.encode(message.bindedSigner, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBindedSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bindedSigner = binded_signer_1.BindedSigner.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetBindedSignerResponse);
        if (object.bindedSigner !== undefined && object.bindedSigner !== null) {
            message.bindedSigner = binded_signer_1.BindedSigner.fromJSON(object.bindedSigner);
        }
        else {
            message.bindedSigner = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bindedSigner !== undefined &&
            (obj.bindedSigner = message.bindedSigner
                ? binded_signer_1.BindedSigner.toJSON(message.bindedSigner)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetBindedSignerResponse);
        if (object.bindedSigner !== undefined && object.bindedSigner !== null) {
            message.bindedSigner = binded_signer_1.BindedSigner.fromPartial(object.bindedSigner);
        }
        else {
            message.bindedSigner = undefined;
        }
        return message;
    },
};
const baseQueryGetActionSignerConfigRequest = { chain: "" };
exports.QueryGetActionSignerConfigRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.chain !== "") {
            writer.uint32(10).string(message.chain);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionSignerConfigRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chain = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionSignerConfigRequest);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = String(object.chain);
        }
        else {
            message.chain = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.chain !== undefined && (obj.chain = message.chain);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionSignerConfigRequest);
        if (object.chain !== undefined && object.chain !== null) {
            message.chain = object.chain;
        }
        else {
            message.chain = "";
        }
        return message;
    },
};
const baseQueryGetActionSignerConfigResponse = {};
exports.QueryGetActionSignerConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actionSignerConfig !== undefined) {
            action_signer_config_1.ActionSignerConfig.encode(message.actionSignerConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionSignerConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionSignerConfig = action_signer_config_1.ActionSignerConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionSignerConfigResponse);
        if (object.actionSignerConfig !== undefined &&
            object.actionSignerConfig !== null) {
            message.actionSignerConfig = action_signer_config_1.ActionSignerConfig.fromJSON(object.actionSignerConfig);
        }
        else {
            message.actionSignerConfig = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actionSignerConfig !== undefined &&
            (obj.actionSignerConfig = message.actionSignerConfig
                ? action_signer_config_1.ActionSignerConfig.toJSON(message.actionSignerConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionSignerConfigResponse);
        if (object.actionSignerConfig !== undefined &&
            object.actionSignerConfig !== null) {
            message.actionSignerConfig = action_signer_config_1.ActionSignerConfig.fromPartial(object.actionSignerConfig);
        }
        else {
            message.actionSignerConfig = undefined;
        }
        return message;
    },
};
const baseQueryAllActionSignerConfigRequest = {};
exports.QueryAllActionSignerConfigRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionSignerConfigRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionSignerConfigRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionSignerConfigRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllActionSignerConfigResponse = {};
exports.QueryAllActionSignerConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.actionSignerConfig) {
            action_signer_config_1.ActionSignerConfig.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionSignerConfigResponse);
        message.actionSignerConfig = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionSignerConfig.push(action_signer_config_1.ActionSignerConfig.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionSignerConfigResponse);
        message.actionSignerConfig = [];
        if (object.actionSignerConfig !== undefined &&
            object.actionSignerConfig !== null) {
            for (const e of object.actionSignerConfig) {
                message.actionSignerConfig.push(action_signer_config_1.ActionSignerConfig.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.actionSignerConfig) {
            obj.actionSignerConfig = message.actionSignerConfig.map((e) => e ? action_signer_config_1.ActionSignerConfig.toJSON(e) : undefined);
        }
        else {
            obj.actionSignerConfig = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionSignerConfigResponse);
        message.actionSignerConfig = [];
        if (object.actionSignerConfig !== undefined &&
            object.actionSignerConfig !== null) {
            for (const e of object.actionSignerConfig) {
                message.actionSignerConfig.push(action_signer_config_1.ActionSignerConfig.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetSyncActionSignerRequest = { id: 0 };
exports.QueryGetSyncActionSignerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).uint64(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetSyncActionSignerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetSyncActionSignerRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = Number(object.id);
        }
        else {
            message.id = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetSyncActionSignerRequest);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = 0;
        }
        return message;
    },
};
const baseQueryGetSyncActionSignerResponse = {};
exports.QueryGetSyncActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.SyncActionSigner !== undefined) {
            sync_action_signer_1.SyncActionSigner.encode(message.SyncActionSigner, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetSyncActionSignerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.SyncActionSigner = sync_action_signer_1.SyncActionSigner.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetSyncActionSignerResponse);
        if (object.SyncActionSigner !== undefined &&
            object.SyncActionSigner !== null) {
            message.SyncActionSigner = sync_action_signer_1.SyncActionSigner.fromJSON(object.SyncActionSigner);
        }
        else {
            message.SyncActionSigner = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.SyncActionSigner !== undefined &&
            (obj.SyncActionSigner = message.SyncActionSigner
                ? sync_action_signer_1.SyncActionSigner.toJSON(message.SyncActionSigner)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetSyncActionSignerResponse);
        if (object.SyncActionSigner !== undefined &&
            object.SyncActionSigner !== null) {
            message.SyncActionSigner = sync_action_signer_1.SyncActionSigner.fromPartial(object.SyncActionSigner);
        }
        else {
            message.SyncActionSigner = undefined;
        }
        return message;
    },
};
const baseQueryAllSyncActionSignerRequest = {};
exports.QueryAllSyncActionSignerRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSyncActionSignerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllSyncActionSignerRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllSyncActionSignerRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllSyncActionSignerResponse = {};
exports.QueryAllSyncActionSignerResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.SyncActionSigner) {
            sync_action_signer_1.SyncActionSigner.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllSyncActionSignerResponse);
        message.SyncActionSigner = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.SyncActionSigner.push(sync_action_signer_1.SyncActionSigner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllSyncActionSignerResponse);
        message.SyncActionSigner = [];
        if (object.SyncActionSigner !== undefined &&
            object.SyncActionSigner !== null) {
            for (const e of object.SyncActionSigner) {
                message.SyncActionSigner.push(sync_action_signer_1.SyncActionSigner.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.SyncActionSigner) {
            obj.SyncActionSigner = message.SyncActionSigner.map((e) => e ? sync_action_signer_1.SyncActionSigner.toJSON(e) : undefined);
        }
        else {
            obj.SyncActionSigner = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllSyncActionSignerResponse);
        message.SyncActionSigner = [];
        if (object.SyncActionSigner !== undefined &&
            object.SyncActionSigner !== null) {
            for (const e of object.SyncActionSigner) {
                message.SyncActionSigner.push(sync_action_signer_1.SyncActionSigner.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.Reader(data)));
    }
    MintRequest(request) {
        const data = exports.QueryGetMintRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "MintRequest", data);
        return promise.then((data) => exports.QueryGetMintRequestResponse.decode(new minimal_1.Reader(data)));
    }
    MintRequestAll(request) {
        const data = exports.QueryAllMintRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "MintRequestAll", data);
        return promise.then((data) => exports.QueryAllMintRequestResponse.decode(new minimal_1.Reader(data)));
    }
    ActionOracleRequest(request) {
        const data = exports.QueryGetActionRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionOracleRequest", data);
        return promise.then((data) => exports.QueryGetActionRequestResponse.decode(new minimal_1.Reader(data)));
    }
    ActionOracleRequestV063(request) {
        const data = exports.QueryGetActionRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionOracleRequestV063", data);
        return promise.then((data) => exports.QueryGetActionRequestResponseV063.decode(new minimal_1.Reader(data)));
    }
    ActionRequestAll(request) {
        const data = exports.QueryAllActionRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionRequestAll", data);
        return promise.then((data) => exports.QueryAllActionRequestResponse.decode(new minimal_1.Reader(data)));
    }
    ActionRequestAllV063(request) {
        const data = exports.QueryAllActionRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionRequestAllV063", data);
        return promise.then((data) => exports.QueryAllActionRequestResponseV063.decode(new minimal_1.Reader(data)));
    }
    CollectionOwnerRequest(request) {
        const data = exports.QueryGetCollectionOwnerRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "CollectionOwnerRequest", data);
        return promise.then((data) => exports.QueryGetCollectionOwnerRequestResponse.decode(new minimal_1.Reader(data)));
    }
    CollectionOwnerRequestAll(request) {
        const data = exports.QueryAllCollectionOwnerRequestRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "CollectionOwnerRequestAll", data);
        return promise.then((data) => exports.QueryAllCollectionOwnerRequestResponse.decode(new minimal_1.Reader(data)));
    }
    OracleConfig(request) {
        const data = exports.QueryGetOracleConfigRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "OracleConfig", data);
        return promise.then((data) => exports.QueryGetOracleConfigResponse.decode(new minimal_1.Reader(data)));
    }
    ActionSigner(request) {
        const data = exports.QueryGetActionSignerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionSigner", data);
        return promise.then((data) => exports.QueryGetActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    ActionSignerAll(request) {
        const data = exports.QueryAllActionSignerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionSignerAll", data);
        return promise.then((data) => exports.QueryAllActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    BindedSigner(request) {
        const data = exports.QueryGetBindedSignerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "BindedSigner", data);
        return promise.then((data) => exports.QueryGetBindedSignerResponse.decode(new minimal_1.Reader(data)));
    }
    ActionSignerConfig(request) {
        const data = exports.QueryGetActionSignerConfigRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionSignerConfig", data);
        return promise.then((data) => exports.QueryGetActionSignerConfigResponse.decode(new minimal_1.Reader(data)));
    }
    ActionSignerConfigAll(request) {
        const data = exports.QueryAllActionSignerConfigRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "ActionSignerConfigAll", data);
        return promise.then((data) => exports.QueryAllActionSignerConfigResponse.decode(new minimal_1.Reader(data)));
    }
    SyncActionSigner(request) {
        const data = exports.QueryGetSyncActionSignerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "SyncActionSigner", data);
        return promise.then((data) => exports.QueryGetSyncActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
    SyncActionSignerAll(request) {
        const data = exports.QueryAllSyncActionSignerRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftoracle.Query", "SyncActionSignerAll", data);
        return promise.then((data) => exports.QueryAllSyncActionSignerResponse.decode(new minimal_1.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
//# sourceMappingURL=query.js.map